import { Component } from "react";
import equal from "fast-deep-equal";

export abstract class DeepPureComponent<T> extends Component<T> {
    public shouldComponentUpdate(props: T) {
        return !equal(this.props, props);
    }
}
